import type { ConversationSummary } from "../../api";

type Props = {
  conversations: ConversationSummary[];
  loading: boolean;
  activeId: string | null;
  onSelect: (id: string) => void;
  onDelete: (id: string) => void;
};

export function ConversationList({ conversations, loading, activeId, onSelect, onDelete }: Props) {
  if (loading && conversations.length === 0) {
    return (
      <div className="conversation-empty conversation-loading">
        Loading
        <span className="thinking-dots" aria-hidden="true" />
      </div>
    );
  }
  if (conversations.length === 0) {
    return <div className="conversation-empty">No conversations yet.</div>;
  }
  return (
    <ul className="conversation-list">
      {conversations.map((c) => (
        <li
          key={c.conversation_id}
          className={c.conversation_id === activeId ? "conversation-list-item--active" : undefined}
        >
          <button
            type="button"
            className="conversation-list-select"
            onClick={() => onSelect(c.conversation_id)}
          >
            <span className="conversation-title">{c.title || "Untitled"}</span>
            <span className="conversation-meta">{relativeTime(c.last_message_at)}</span>
          </button>
          <button
            type="button"
            className="conversation-list-delete"
            aria-label={`Delete conversation ${c.title || "Untitled"}`}
            title="Delete"
            onClick={(e) => {
              e.stopPropagation();
              if (window.confirm(`Delete "${c.title || "Untitled"}"? This cannot be undone.`)) {
                onDelete(c.conversation_id);
              }
            }}
          >
            ×
          </button>
        </li>
      ))}
    </ul>
  );
}

function relativeTime(iso: string): string {
  const ts = new Date(iso).getTime();
  if (Number.isNaN(ts)) return "";
  const diff = Date.now() - ts;
  const min = Math.round(diff / 60_000);
  if (min < 1) return "just now";
  if (min < 60) return `${min}m ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.round(hr / 24);
  if (day < 7) return `${day}d ago`;
  return new Date(iso).toLocaleDateString();
}
